<template>
  <div id="company_info" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>查看企業請款單</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <h4 class="col-md-3">1.企業: {{ companyInfo.companyName }}</h4>
      <h4 class="col-md-1">2.月份:</h4>
      <input
        type="month"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.requestDate"
        :disabled="!showEditFunction"
      />
      <h4 class="col-md-1">3.主標題:</h4>
      <input
        type="text"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.title"
        :disabled="!showEditFunction"
      />
      <h4 class="col-md-1">4.請款日:</h4>
      <input
        type="date"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.requestOrderDate"
        :disabled="!showEditFunction"
      />
    </div>
    <hr />
    <div class="row">
      <h4 class="col-md-1">5.預估收款日(必填):</h4>
      <input
        type="date"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.estimatedReceiveDate"
        :disabled="!showEditFunction"
      />
      <h4 class="col-md-1">6.預估司機領款日(必填):</h4>
      <input
        type="date"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.driverReceivePaymentDate"
        :disabled="!showEditFunction"
      />
      <h4 class="col-md-1">7. 請款單備註:</h4>
      <input
        type="text"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.invoiceNote"
        :disabled="!showEditFunction"
      />
      <h4 class="col-md-1">8. 實際企業付款日期:</h4>
      <input
        type="date"
        class="inputstyle fontSize16 col-md-2 col-sm-2 col-xs-2"
        v-model="companyInfo.actualReceiveDate"
        :disabled="!showEditFunction"
      />
    </div>
    <hr />
    <div class="row">
      <div v-show="showEditFunction" class="col-md-1"></div>
      <div class="pull-right">
        <button
          class="btn btn-success"
          v-show="!showEditFunction && companyInfo.actualReceiveDate === null"
          @click="editInvoice"
        >
          編輯
        </button>
        <div v-show="showEditFunction">
          <button class="btn btn-success" @click="updateInvoice">更新</button>
          <button class="btn btn-danger" @click="cancelShow">取消</button>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize16">
            <th class="column-title">公司名稱</th>
            <th class="column-title">簽單建立日期</th>
            <th class="column-title">上車地點</th>
            <th class="column-title">下車地點</th>
            <th class="column-title">乘客名稱</th>
            <th class="column-title">簽單備註</th>
            <th class="column-title">乘客備註</th>
            <th class="column-title">客服備註</th>
            <th class="column-title">司機金額</th>
            <th class="column-title">服務費</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(bill, index) in signing">
            <tr class="pointer fontSize16">
              <td>{{ bill.companyName }}</td>
              <td>{{ bill.createdAt }}</td>
              <td>{{ bill.onAddress }}</td>
              <td>{{ bill.offAddress }}</td>
              <td>{{ bill.employeeNameJobNumber }}</td>
              <td>{{ bill.signingNote }}</td>
              <td>{{ bill.serviceNote }}</td>
              <td>{{ bill.passengerNote }}</td>
              <td>{{ bill.actualFare }}</td>
              <td>{{ bill.serviceFee }}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="pull-right">
        <ul class="pagination">
          <li v-bind:class="{ disabled: page == 1 }">
            <a
              href="javascript:;"
              @click="clickNewPage(1)"
              v-bind:class="{ active: page == 1 }"
            >
              第一頁
            </a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="clickNewPage(pages_show_list[0] - 1)"
              v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1"
            >
              ...
            </a>
          </li>
          <li
            v-for="n in pages_show_list"
            v-bind:class="{ active: n == page }"
            @click="clickNewPage(n)"
          >
            <a href="javascript:;" ng-bind="n">{{ n }}</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="clickNewPage(pages_show_list[4] + 1)"
              v-show="
                page + 2 < totalPage && pages_show_list[4] + 1 < totalPage
              "
            >
              ...
            </a>
          </li>
          <li
            v-show="totalPage > 1"
            v-bind:class="{ disabled: page == totalPage }"
          >
            <a
              href="javascript:;"
              @click="clickNewPage(totalPage)"
              v-bind:class="{ active: page == totalPage }"
            >
              最後一頁
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'
import moment from 'moment'
export default {
  data() {
    return {
      showEditFunction: false,
      totalPage: 1,
      pages_show_list: [],
      page: 1,
      companyInfo: {
        companyName: '',
        requestDate: '',
        title: '',
        requestOrderDate: '',
        estimatedReceiveDate: '',
        invoiceNote: '',
        driverReceivePaymentDate: '',
        actualReceiveDate: '',
      },
      signing: [],
      invoiceId: -1,
      enterpriseId: -1,
    }
  },
  mounted() {
    this.invoiceId = this.$route.query.id
    this.enterpriseId = this.$route.query.enterpriseId
    this.getInvoice(this.invoiceId)
  },
  methods: {
    updateInvoice() {
      let invoiceInfo = {
        invoiceId: this.invoiceId,
        enterpriseId: this.enterpriseId,
        requestDate: this.companyInfo.requestDate,
        title: this.companyInfo.title,
        requestOrderDate: this.companyInfo.requestOrderDate,
        estimatedReceiveDate: this.companyInfo.estimatedReceiveDate,
        invoiceNote: this.companyInfo.invoiceNote,
        driverReceivePaymentDate: this.companyInfo.driverReceivePaymentDate,
        actualReceiveDate: this.companyInfo.actualReceiveDate,
      }
      console.log(invoiceInfo)
      EnterpriseAPI.put(`enterprise/invoice/info`, invoiceInfo)
        .then((res) => {
          if (res.success) {
            alert('更新成功')
            this.cancelShow()
          } else {
            alert('更新失敗')
          }
        })
        .catch((err) => {
          console.log(err)
          this.$msg('網路連線異常')
        })
    },
    editInvoice() {
      this.showEditFunction = !this.showEditFunction
    },
    cancelShow() {
      this.showEditFunction = !this.showEditFunction
    },
    getInvoice(id) {
      EnterpriseAPI.get(`enterprise/invoice?task=single&invoiceId=${id}`)
        .then((res) => {
          this.signing = res.result.signingList
          this.companyInfo = res.result.info
          this.companyInfo.companyName = this.companyInfo.companyName
          this.companyInfo.requestDate = moment(
            this.companyInfo.requestDate,
          ).format('YYYY-MM')
          this.companyInfo.title = this.companyInfo.title
          this.companyInfo.requestOrderDate = moment(
            this.companyInfo.requestOrderDate,
          ).format('YYYY-MM-DD')
          this.companyInfo.estimatedReceiveDate = moment(
            this.companyInfo.estimatedReceiveDate,
          ).format('YYYY-MM-DD')
          this.companyInfo.invoiceNote = this.companyInfo.invoiceNote
          this.companyInfo.driverReceivePaymentDate = moment(
            this.companyInfo.driverReceivePaymentDate,
          ).format('YYYY-MM-DD')
          this.companyInfo.actualReceiveDate =
            this.companyInfo.actualReceiveDate === null
              ? null
              : moment(this.companyInfo.actualReceiveDate).format('YYYY-MM-DD')
        })
        .catch((err) => {
          console.log(err)
          this.$msg('網路連線異常')
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/company/EditInvoice.vue